/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 */

let autobuildProfiles,
	awards,
	biography,
	count,
	courses,
	department,
	directoryTags,
	email,
	fullSearch,
	image,
	jobTypes,
	layout,
	office,
	phone,
	profileAddress,
	profileCV,
	profileEducationHistory,
	profileEmail,
	profileExpertsUrl,
	profileImage,
	profileLinks,
	profileOffice,
	profileOrganizations,
	profilePhone,
	profileTags,
	profileTitle,
	publications,
	research,
	searchQuery,
	showLayout,
	showOffices,
	showTags,
	showSearch,
	tags,
	personCount;
let pagination = {};
let directoryUrl;
const params = new URLSearchParams(window.location.search);

function loadAll(url) {
	fetch(url, {
		method: "GET",
		headers: {
			"Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
		},
	})
		.then((res) => res.json())
		.then((data) => {
			if (layout == "grid") {
				createGrid(data.people);
			}
			if (layout == "list") {
				createList(data.people);
			}
			if (layout == "table") {
				createTable(data.people);
			}
			personCount = data.count;
			console.log(data.count);
			if (personCount == 0) {
				pagination = {
					totalItems: 0,
					currentPage: 0,
					pageSize: count,
					totalPages: 0,
					startPage: 0,
					endPage: 0,
					startIndex: 0,
					endIndex: 0,
					pages: [],
				};
			}
			if (personCount - count > 0) {
				createPagination();
			} else {
				removePagination();
			}
			if (showSearch) {
				createSearch();
			}
			if (showLayout) {
				createLayoutDropdown();
			}
			if (showTags || showOffices) {
				createDropdown();
			}
		});
}

function main() {
	const dirAttributes = document.querySelector("#directory-content-panel");
	autobuildProfiles =
		dirAttributes.dataset.autobuildprofiles == "true" ? true : false;
	awards = dirAttributes.dataset.awards == "true" ? true : false;
	biography = dirAttributes.dataset.biography == "true" ? true : false;
	count = parseInt(dirAttributes.dataset.count);
	courses = dirAttributes.dataset.courses == "true" ? true : false;
	department = dirAttributes.dataset.department;
	directoryTags = dirAttributes.dataset.directorytags == "true" ? true : false;
	email = dirAttributes.dataset.email == "true" ? true : false;
	fullSearch = dirAttributes.dataset.fullsearch == "true" ? true : false;
	image = dirAttributes.dataset.image == "true" ? true : false;
	jobTypes = "";
	layout = dirAttributes.dataset.layout;
	office = dirAttributes.dataset.office;
	phone = dirAttributes.dataset.phone == "true" ? true : false;
	profileAddress =
		dirAttributes.dataset.profileaddress == "true" ? true : false;
	profileCV = dirAttributes.dataset.profilecv == "true" ? true : false;
	profileEducationHistory =
		dirAttributes.dataset.profileeducationhistory == "true" ? true : false;
	profileEmail = dirAttributes.dataset.profileemail == "true" ? true : false;
	profileExpertsUrl =
		dirAttributes.dataset.profileexpertsurl == "true" ? true : false;
	profileImage = dirAttributes.dataset.profileimage == "true" ? true : false;
	profileLinks = dirAttributes.dataset.profilelinks == "true" ? true : false;
	profileOffice = dirAttributes.dataset.profileoffice == "true" ? true : false;
	profileOrganizations =
		dirAttributes.dataset.profileorganizations == "true" ? true : false;
	profilePhone = dirAttributes.dataset.profilephone == "true" ? true : false;
	profileTags = dirAttributes.dataset.profiletags == "true" ? true : false;
	profileTitle = dirAttributes.dataset.profiletitle == "true" ? true : false;
	publications = dirAttributes.dataset.publications;
	research = dirAttributes.dataset.research;
	searchQuery = dirAttributes.dataset.searchquery;
	showLayout = dirAttributes.dataset.showlayout == "true" ? true : false;
	showOffices = dirAttributes.dataset.showoffices == "true" ? true : false;
	showTags = dirAttributes.dataset.showtags == "true" ? true : false;
	showSearch = dirAttributes.dataset.showsearch == "true" ? true : false;
	tags = dirAttributes.dataset.tags;
	count = parseInt(dirAttributes.dataset.count);
	if (params) {
		if (params.has("department") && params.get("department") != "") {
			department = params.get("department");
		}
		if (params.has("q") && params.get("q") != "") {
			searchQuery = params.get("q");
		}
		if (params.has("offices") && params.get("offices") != "") {
			office = params.get("offices");
		}
		if (params.has("tags") && params.get("tags") != "") {
			tags = params.get("tags");
		}
		if (params.has("take") && params.get("take") != "") {
			count = parseInt(params.get("take"));
		}
		if (params.has("layout") && params.get("layout") != "") {
			layout = params.get("layout");
		}
		if (params.has("image") && params.get("image") != "") {
			image = params.get("image") == "true" ? true : false;
		}
		if (params.has("email") && params.get("email") != "") {
			email = params.get("email") == "true" ? true : false;
		}
		if (params.has("phone") && params.get("phone") != "") {
			phone = params.get("phone") == "true" ? true : false;
		}
		if (params.has("showlayout") && params.get("showlayout") != "") {
			showLayout = params.get("showlayout") == "true" ? true : false;
		}
		if (params.has("showoffices") && params.get("showoffices") != "") {
			showOffices = params.get("showoffices") == "true" ? true : false;
		}
		if (params.has("showtags") && params.get("showtags") != "") {
			showTags = params.get("showtags") == "true" ? true : false;
		}
		if (params.has("showsearch") && params.get("showsearch") != "") {
			showSearch = params.get("showsearch") == "true" ? true : false;
		}
		if (params.has("jobtypes") && params.get("jobtypes") != "") {
			jobTypes = params.get("jobtypes");
		}
	}
	if (params.has("profile") && params.get("profile") != "") {
		getProfile(params.get("profile"));
	} else if (window.location.pathname.includes("profile")) {
		let path = window.location.pathname.split("/");
		let profileId = path.indexOf("profile") + 1;
		getProfile(path[profileId]);
	} else {
		directoryUrl = `https://directoryapi.wigg.illinois.edu/api/Directory/Search/${department}?q=${searchQuery}&useFullText=${fullSearch}&offices=${office}&jobTypes=${jobTypes}&tags=${tags}&take=${count}`;
		loadAll(directoryUrl);
	}
}

function createGrid(people) {
	let faculty = document.getElementById("directory-profile-list");
	faculty.innerHTML = `<ul class="directory-grid"></ul>`;
	for (let i = 0; i < people.length; i++) {
		let li = document.createElement("li");
		let profileUrl = autobuildProfiles
			? `./profile/${people[i].netId}`
			: `${people[i].profileUrl}`;
		let htmlProfile = `<il-profile-card><img src="${people[i].imageUrl}" alt="${people[i].fullName}"><h2 class="heading"><a href="${profileUrl}">${people[i].fullName}</a></h2>`;
		if (people[i].primaryTitle && people[i].primaryTitle != "") {
			htmlProfile += `<p>${people[i].primaryTitle}</p>`;
		}
		if (people[i].primaryOffice && people[i].primaryOffice != "") {
			htmlProfile += `<p class="il-contact-department">${people[i].primaryOffice}</p>`;
		}
		if (phone && people[i].phoneFormatted && people[i].phoneFormatted != "") {
			htmlProfile += `<p class="il-contact-phone"><a href="tel:${people[i].phoneFormatted}">${people[i].phoneFormatted}</a></p>`;
		}
		if (email && people[i].email && people[i].email != "") {
			htmlProfile += `<p class="il-contact-email"><a href="mailto:${people[i].email}">${people[i].email}</a></p>`;
		}
		if (directoryTags) {
			htmlProfile += buildTags(people[i]);
		}

		htmlProfile += "</il-profile-card>";
		li.innerHTML = htmlProfile;
		faculty.firstChild.appendChild(li);
	}
}

function createList(people) {
	let faculty = document.getElementById("directory-profile-list");
	faculty.innerHTML = `<ul class="directory-list"></ul>`;
	for (let i = 0; i < people.length; i++) {
		let person = people[i];
		let profileUrl = autobuildProfiles
			? `./profile/${person.netId}`
			: `${person.profileUrl}`;
		let htmlProfile = `
		${
			person.imageUrl && image
				? `<div class="directory-portrait"><img src="${person.imageUrl}" alt="${person.fullName}" /></div>`
				: ""
		}
		<div>
			<h2 class="heading">
				<a href="${profileUrl}">${person.fullName}</a>
			</h2>
			<p>
				${person.primaryTitle ? `<span>${person.primaryTitle}</span>` : ""}
				${
					person.primaryTitle && person.primaryOffice
						? `&nbsp;<span class="separator"></span>&nbsp;`
						: ""
				}
				${
					person.primaryOffice
						? `<span class="il-contact-department">${person.primaryOffice}</span>`
						: ""
				}
			</p>
			${
				person.phoneFormatted && phone
					? `<span class="il-contact-phone"><a href="tel:${person.phoneFormatted}">${person.phoneFormatted}</a></span>`
					: ""
			}
			${
				person.email && email && person.phoneFormatted && phone
					? `&nbsp;<span class="separator"></span>&nbsp;`
					: ""
			}
			${
				person.email && email
					? `<span class="il-contact-email"><a href="mailto:${person.email}">${person.email}</a></span>`
					: ""
			}
			${directoryTags ? buildTags(person) : ""}
		</div>`;
		let li = document.createElement("li");
		li.innerHTML = htmlProfile;
		faculty.firstChild.appendChild(li);
	}
}

function createTable(people) {
	let faculty = document.getElementById("directory-profile-list");
	let table = `
	<table id="directory-profile-list">
	<tr>
	<th>Name</th>
	<th>Title</th>
	${email ? `<th>Email</th>` : ""}
	${phone ? `<th>Phone</th>` : ""}
	</tr>`;
	for (let i = 0; i < people.length; i++) {
		let person = people[i];
		let profileUrl = autobuildProfiles
			? `./profile/${person.netId}`
			: `${person.profileUrl}`;
		table =
			table +
			`
		<tr>
		<td><a href="${profileUrl}">${person.fullName}</a></td>
		<td>
			${person.primaryTitle ? `<span>${person.primaryTitle}</span>` : ""}
			${person.primaryTitle && person.primaryOffice ? `<br>` : ""}
			${
				person.primaryOffice
					? `<span class="il-contact-department">${person.primaryOffice}</span>`
					: ""
			}
			${directoryTags ? buildTags(person) : ""}
		</td>
		${
			email
				? `<td>${
						person.email
							? `<span class="il-contact-email"><a href="mailto:${person.email}"</a>${person.email}</span>`
							: ""
				  }</td>`
				: ""
		}
		${
			phone
				? `<td>${
						person.phoneFormatted
							? `<span class="il-contact-phone"><a href="tel:${person.phoneFormatted}"</a>${person.phoneFormatted}</span>`
							: ""
				  }</td>`
				: ""
		}
		</tr>
		`;
	}
	table = table + `</table>`;
	faculty.outerHTML = table;
}

function removePagination() {
	if (document.getElementById("pagination-top-container")) {
		document.getElementById("pagination-top-container").remove();
	}
	if (document.getElementById("pagination-bottom-container")) {
		document.getElementById("pagination-bottom-container").remove();
	}
	if (document.getElementsByClassName("directory-pagination").length > 0) {
		Array.from(document.getElementsByClassName("directory-pagination")).forEach(
			(element) => element.remove(),
		);
	}
}

function createPagination() {
	removePagination();
	paginate(personCount, pagination.currentPage, parseInt(count));
	let paginationLinkBar = `<div id="pagination" class="directory-pagination"><ul><li class="page-number">Page ${pagination.currentPage} of ${pagination.totalPages}</li>`;
	if (
		pagination.currentPage != pagination.startPage &&
		pagination.totalPages > 1
	) {
		paginationLinkBar =
			paginationLinkBar +
			`<li><button id="paginate-firstpage aria-label="Go to First Directory Page"">First</button></li><li><button id="paginate-previouspage" aria-label="Go to Previous Directory Page">Previous</button></li>`;
	}
	if (pagination.pages.length > 10) {
		let pageArray = pagination.pages;
		if (pagination.currentPage < 6) {
			pageArray = [1, 2, 3, 4, 5, 6, 7];
		} else {
			pageArray = pageArray.slice(
				pagination.currentPage - 4,
				pagination.currentPage + 3,
			);
		}
		pageArray.map(
			(num) =>
				(paginationLinkBar =
					paginationLinkBar +
					`<li><button aria-label="Directory Page ${num}" ${
						num == pagination.currentPage ? `aria-current="page"` : ""
					} ${
						num == pagination.currentPage ? `class="current"` : ""
					}>${num}</button></li>`),
		);
	} else {
		pagination.pages.map(
			(num) =>
				(paginationLinkBar =
					paginationLinkBar +
					`<li><button aria-label="Directory Page ${num}" ${
						num == pagination.currentPage ? `aria-current="page"` : ""
					} ${
						num == pagination.currentPage ? `class="current"` : ""
					}>${num}</button></li>`),
		);
	}
	if (
		pagination.currentPage != pagination.endPage &&
		pagination.totalPages > 1
	) {
		paginationLinkBar =
			paginationLinkBar +
			`<li><button id="paginate-nextpage" aria-label="Go to Next Directory Page">Next</button></li><li><button id="paginate-lastpage" aria-label="Go to Last Directory Page">Last</button></li>`;
	}
	paginationLinkBar = paginationLinkBar + `</ul></div>`;

	let faculty = document.getElementById("directory-profile-list");
	let paginationTop = document.createElement("div");
	paginationTop.id = "pagination-top-container";
	let paginationBottom = document.createElement("div");
	paginationTop.innerHTML = paginationBottom.innerHTML = paginationLinkBar;
	paginationBottom.firstChild.id = "pagination-bottom";
	paginationBottom.id = "pagination-bottom-container";
	faculty.before(paginationTop);
	faculty.after(paginationBottom);
	const pageButtons = document.querySelectorAll(".directory-pagination button");
	pageButtons.forEach((button) =>
		button.addEventListener("click", incrementPage),
	);
}

function paginate(totalItems, currentPage = 1, pageSize = 12, maxPages = 1000) {
	console.log("Paginate Total Items");
	console.log(totalItems);
	// calculate total pages
	let totalPages = Math.ceil(totalItems / pageSize);

	// ensure current page isn't out of range
	if (currentPage < 1) {
		currentPage = 1;
	} else if (currentPage > totalPages) {
		currentPage = totalPages;
	}

	let startPage, endPage;
	if (totalPages <= maxPages) {
		// total pages less than max so show all pages
		startPage = 1;
		endPage = totalPages;
	} else {
		// total pages more than max so calculate start and end pages
		let maxPagesBeforeCurrentPage = Math.floor(maxPages / 2);
		let maxPagesAfterCurrentPage = Math.ceil(maxPages / 2) - 1;
		if (currentPage <= maxPagesBeforeCurrentPage) {
			// current page near the start
			startPage = 1;
			endPage = maxPages;
		} else if (currentPage + maxPagesAfterCurrentPage >= totalPages) {
			// current page near the end
			startPage = totalPages - maxPages + 1;
			endPage = totalPages;
		} else {
			// current page somewhere in the middle
			startPage = currentPage - maxPagesBeforeCurrentPage;
			endPage = currentPage + maxPagesAfterCurrentPage;
		}
	}

	// calculate start and end item indexes
	let startIndex = (currentPage - 1) * pageSize;
	let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

	// create an array of pages to ng-repeat in the pager control
	let pages = Array.from(Array(endPage + 1 - startPage).keys()).map(
		(i) => startPage + i,
	);
	pagination = {
		totalItems: totalItems,
		currentPage: currentPage,
		pageSize: pageSize,
		totalPages: totalPages,
		startPage: startPage,
		endPage: endPage,
		startIndex: startIndex,
		endIndex: endIndex,
		pages: pages,
	};
	// return object with all pager properties required by the view
	return;
}

function incrementPage(button) {
	let url = `https://directoryapi.wigg.illinois.edu/api/Directory/Search/${department}?q=${searchQuery}&useFullText=${fullSearch}&offices=${office}&tags=${tags}&take=`;
	if (parseInt(button.currentTarget.innerText) > 1) {
		pagination.currentPage = parseInt(button.currentTarget.innerText);
		directoryUrl =
			url +
			pagination.pageSize +
			"&skip=" +
			pagination.pageSize * (pagination.currentPage - 1);
	}
	if (
		button.currentTarget.innerText == "First" ||
		parseInt(button.currentTarget.innerText) == 1
	) {
		pagination.currentPage = pagination.startPage;
		directoryUrl = url + pagination.pageSize;
	}
	if (button.currentTarget.innerText == "Previous") {
		pagination.currentPage--;
		directoryUrl =
			url +
			pagination.pageSize +
			"&skip=" +
			pagination.pageSize * (pagination.currentPage - 1);
	}
	if (button.currentTarget.innerText == "Next") {
		pagination.currentPage++;
		directoryUrl =
			url +
			pagination.pageSize +
			"&skip=" +
			pagination.pageSize * (pagination.currentPage - 1);
	}
	if (button.currentTarget.innerText == "Last") {
		pagination.currentPage = pagination.endPage;
		directoryUrl =
			url +
			pagination.pageSize +
			"&skip=" +
			pagination.pageSize * (pagination.currentPage - 1);
	}
	loadAll(directoryUrl);
}

function createSearch() {
	if (document.getElementById("directory-searchbox")) {
		return;
	}
	let searchbar = `<div id="directory-search-toolbar" aria-label="Faculty Search" role="search"><input id="directory-searchbox" placeholder="Name or keyword"></input><button class="il-button" id="directory-search-button">Search ›</button></div>`;
	let contentPanel = document.getElementById("directory-content-panel");
	contentPanel.insertAdjacentHTML("beforebegin", searchbar);
	let searchbarInput = document.getElementById("directory-searchbox");
	//searchbarInput.addEventListener("input", updateSearch);
	let searchbarButton = document.getElementById("directory-search-button");
	searchbarInput.addEventListener("keypress", function (event) {
		// If the user presses the "Enter" key on the keyboard
		if (event.key === "Enter" && document.activeElement === searchbarInput) {
			// Cancel the default action, if needed
			event.preventDefault();
			// Trigger the button element with a click
			updateSearch();
		}
	});
	searchbarButton.addEventListener("click", updateSearch);
}

function updateSearch() {
	searchQuery = document.getElementById("directory-searchbox").value;
	pagination.currentPage = 1;
	directoryUrl = `https://directoryapi.wigg.illinois.edu/api/Directory/Search/${department}?q=${searchQuery}&useFullText=${fullSearch}&offices=${office}&tags=${tags}&take=${count}`;
	loadAll(directoryUrl);
}

function createDropdown() {
	if (
		document.getElementById("directory-tag-dropdown") ||
		document.getElementById("directory-office-dropdown")
	) {
		return;
	}
	let officesUrl = `https://directoryapi.wigg.illinois.edu/api/Area/Code/${department}`;
	let tagDropdown, officeDropdown;
	fetch(officesUrl, {
		method: "GET",
		headers: {
			"Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
		},
	})
		.then((res) => res.json())
		.then((data) => {
			if (showTags && data.tags.length > 0) {
				const tagData = data.tags.map((val) => ({ label: val, value: val }));
				tagData.sort((a, b) => a.label.localeCompare(b.label));
				tagData.unshift({ label: "Select Filter", value: "" });
				const tagArray = tagData.map((item) => {
					return `<option value="${item.value}">${item.label}</option>`;
				});
				tagDropdown = `<select id="directory-tag-dropdown">${tagArray.join(
					"",
				)}</select>`;
			}
			if (showOffices && data.offices.length > 0) {
				const officeData = data.offices.map(({ title }) => ({
					label: title,
					value: title,
				}));
				officeData.sort((a, b) => a.label.localeCompare(b.label));
				officeData.unshift({ label: "All Departments", value: "" });
				const officeArray = officeData.map((item) => {
					return `<option value="${item.value}">${item.label}</option>`;
				});
				officeDropdown = `<select id="directory-office-dropdown">${officeArray.join(
					"",
				)}</select>`;
			}
			let dropdowns = `${showTags ? `${tagDropdown}` : ""}${
				showOffices ? `${officeDropdown}` : ""
			}`;

			if (!document.getElementById("directory-search-toolbar")) {
				let searchbar = `<div id="directory-search-toolbar"></div>`;
				let contentPanel = document.getElementById("directory-content-panel");
				let searchContainer = document.createElement("div");
				searchContainer.innerHTML = searchbar;
				contentPanel.before(searchContainer);
			}

			if (document.getElementById("directory-layout-dropdown")) {
				document
					.getElementById("directory-layout-dropdown")
					.insertAdjacentHTML("afterend", dropdowns);
			} else {
				let searchDiv = document.getElementById("directory-search-toolbar");
				searchDiv.insertAdjacentHTML("afterbegin", dropdowns);
			}

			if (document.getElementById("directory-tag-dropdown")) {
				document
					.getElementById("directory-tag-dropdown")
					.addEventListener("input", updateTag);
				setSelected(document.getElementById("directory-tag-dropdown"), tags);
			}
			if (document.getElementById("directory-office-dropdown")) {
				document
					.getElementById("directory-office-dropdown")
					.addEventListener("input", updateOffice);
				setSelected(
					document.getElementById("directory-office-dropdown"),
					office,
				);
			}
			//searchDiv.before(dropdownContainer);
			if (showOffices && params.has("offices") && params.get("offices") != "") {
				document.getElementById("directory-office-dropdown").value =
					params.get("offices");
			}
			if (showTags && params.has("tags") && params.get("tags") != "") {
				document.getElementById("directory-tag-dropdown").value =
					params.get("tags");
			}
			if (showLayout && params.has("layout") && params.get("layout") != "") {
				document.getElementById("directory-layout-dropdown").value =
					params.get("layout");
			}
		});
	return;
}

function updateTag() {
	tags = document.getElementById("directory-tag-dropdown").value;
	pagination.currentPage = 1;
	//CHECK: Might need to use pagination.pageSize instead of count
	directoryUrl = `https://directoryapi.wigg.illinois.edu/api/Directory/Search/${department}?q=${searchQuery}&useFullText=${fullSearch}&offices=${office}&tags=${tags}&take=${count}`;
	loadAll(directoryUrl);
}

function updateOffice() {
	office = document.getElementById("directory-office-dropdown").value;
	pagination.currentPage = 1;
	//CHECK: Might need to use pagination.pageSize instead of count
	directoryUrl = `https://directoryapi.wigg.illinois.edu/api/Directory/Search/${department}?q=${searchQuery}&useFullText=${fullSearch}&offices=${office}&tags=${tags}&take=${count}`;
	loadAll(directoryUrl);
}

function createLayoutDropdown() {
	if (document.getElementById("directory-layout-dropdown")) {
		return;
	}
	let layoutDropdown = `<select id="directory-layout-dropdown"><option value="grid">Grid</option><option value="list">List</option><option value="table">Table</option></select>`;
	if (!document.getElementById("directory-search-toolbar")) {
		let searchbar = `<div id="directory-search-toolbar"></div>`;
		let contentPanel = document.getElementById("directory-content-panel");
		contentPanel.insertAdjacentHTML("beforebegin", searchbar);
	}
	document
		.getElementById("directory-search-toolbar")
		.insertAdjacentHTML("afterbegin", layoutDropdown);
	document
		.getElementById("directory-layout-dropdown")
		.addEventListener("input", updateLayout);
	setSelected(document.getElementById("directory-layout-dropdown"), layout);
}

function updateLayout() {
	layout = document.getElementById("directory-layout-dropdown").value;
	document.getElementById("directory-profile-list").innerHTML = "";
	directoryUrl = `https://directoryapi.wigg.illinois.edu/api/Directory/Search/${department}?q=${searchQuery}&useFullText=${fullSearch}&offices=${office}&tags=${tags}&take=${count}`;
	loadAll(directoryUrl);
}

function setSelected(element, value) {
	element.childNodes.forEach(function (node, index) {
		if (node.value == value) {
			node.setAttribute("selected", "");
		}
	});
}

function getProfile(username) {
	let profilePanel = document.getElementById("directory-content-panel");
	document.getElementsByClassName("entry-title")[0].hidden = true;
	if (profilePanel.parentElement.className.includes("alignfull")) {
		profilePanel.parentElement.classList.remove("alignfull");
		profilePanel.parentElement.parentElement.classList.remove("alignfull");
	}
	profileUrl = `https://directoryapi.wigg.illinois.edu/api/Directory/GetProfile/${department}/${username}`;
	fetch(profileUrl, {
		method: "GET",
		headers: {
			"Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
		},
	})
		.then((res) => res.json())
		.then((data) => {
			profilePanel.innerHTML = "";
			profilePanel.innerHTML = createProfile(data);
			if (image && data.imageUrl != "") {
				processImage(
					document.getElementById("il-directory-profile-photo").firstChild,
				);
			}
		});
}

function createProfile(data) {
	let profileTemplate = `${buildBackButton()}<il-profile>
	<section slot="primary">
	<h1>${data.fullName}</h1>
	${data.primaryTitle != "" && profileTitle ? `<p>${data.primaryTitle}</p>` : ""}
	${
		data.primaryOffice != "" && profileOffice
			? `<p class="il-contact-department">${data.primaryOffice}</p>`
			: ""
	}
	${profileTags ? buildTags(data) : ""}
	</section>
	<section slot="contact">
	${
		profileImage && data.imageUrl != ""
			? `<div class="il-contact-photo" id="il-directory-profile-photo"><img src="${data.imageUrl}" alt="${data.fullName}"></div>`
			: ""
	}
	<h2>Contact Information</h2>
	<div class="il-contact-address">
	${
		data.addressLine1 != "" && profileAddress
			? `<p>${data.addressLine1}</p>`
			: ""
	}
	${
		data.addressLine2 != "" && profileAddress
			? `<p>${data.addressLine2}</p>`
			: ""
	}
	${
		data.city != "" && data.state != "" && profileAddress
			? `<p>${data.city}, ${data.state} ${data.zip}</p>`
			: ""
	}
	</div>
	${
		data.phoneFormatted != "" && profilePhone
			? `<p class="il-contact-phone"><a href="tel:${data.phone}">${data.phoneFormatted}</a></p>`
			: ""
	}
	${
		data.email != "" && profileEmail
			? `<p class="il-contact-email"><a href="${data.email}">${data.email}</a></p>`
			: ""
	}
	${
		data.expertsUrl != "" && profileExpertsUrl
			? `<p class="il-contact-website"><a href="${data.expertsUrl}">Illinois Experts</a></p>`
			: ""
	}
	${
		data.cvUrl != "" && profileCV
			? `<p class="il-contact-cv"><a href="${data.cvUrl}">Download CV</a></p>`
			: ""
	}
	</section>
	${
		data.biography != "" && biography
			? `	<section>
		<h2>Biography</h2>
		${data.biography}
		</section>`
			: ""
	}
	${
		data.organizations != "" && profileOrganizations
			? `${buildAppointments(data.organizations)}`
			: ""
	}
	${
		data.educationHistory != "" && profileEducationHistory
			? `${buildEducation(data.educationHistory)}`
			: ""
	}
	${data.awards != "" && awards ? `${buildAwards(data.awards)}` : ""}
	${data.links != "" && profileLinks ? `${buildLinks(data.links)}` : ""}
	${
		data.researchStatement != "" && research
			? `<section><h2>Research & Service</h2>${data.researchStatement}</section>`
			: ""
	}
	${
		data.publications != "" && publications
			? `${buildPublications(data.publications)}`
			: ""
	}
	${data.courses != "" && courses ? `${buildCourses(data.courses)}` : ""}
	</il-profile>`;
	return profileTemplate;
}

function buildAppointments(organizations) {
	let appointmentArray = organizations.map((item) => {
		return `<li>${item.title}, ${item.institution}</li>`;
	});
	return `<section>
	<h2>Key Professional Appointments</h2>
	<ul>
	${appointmentArray.join("")}
	</ul>
	</section>`;
}

function buildEducation(education) {
	let educationArray = education.map((item) => {
		return `<li>${item.title}, ${item.institution}</li>`;
	});
	return `<section>
	<details>
	<summary>
	Educational History
	</summary>
	<ul>
	${educationArray.join("")}
	</ul>
	</details>
	</section>`;
}

function buildAwards(awards) {
	let awardsArray = awards.map((item) => {
		return `<li>${item.title}, ${item.year}</li>`;
	});
	return `<section>
	<details>
	<summary>
	Awards
	</summary>
	<ul>
	${awardsArray.join("")}
	</ul>
	</details>
	</section>`;
}

function buildLinks(links) {
	let linksArray = links.map((item) => {
		return `<li><a href="${item.url}">${item.title}</a></li>`;
	});
	return `<section>
	<details>
	<summary>
	Links
	</summary>
	<ul>
	${linksArray.join("")}
	</ul>
	</details>
	</section>`;
}

function buildPublications(publications) {
	let publicationsArray = publications.map((item) => {
		return `<li>${
			item.url != ""
				? `<a href="${item.url}">${item.title}</a>`
				: `${item.title}`
		}</li>`;
	});
	return `<section>
	<details>
	<summary>
	Publications
	</summary>
	<ul>
	${publicationsArray.join("")}
	</ul>
	</details>
	</section>`;
}

function buildCourses(courses) {
	let coursesArray = courses.map((item) => {
		return `<li>${
			item.url != null
				? `<a href="${item.url}">${item.title}:</a> ${item.description}`
				: `${item.title}: ${item.description}`
		}</li>`;
	});
	return `<section>
	<details>
	<summary>
	Courses
	</summary>
	<ul>
	${coursesArray.join("")}
	</ul>
	</details>
	</section>`;
}

function buildTags(person) {
	let tagList = ``;
	for (let j = 0; j < person.jobProfiles.length; j++) {
		for (let t = 0; t < person.jobProfiles[j].tags.length; t++) {
			tagList += `<p class="il-tag">${person.jobProfiles[j].tags[t]}</p>`;
		}
	}
	return tagList;
}

function buildBackButton() {
	let url = window.location.pathname.slice(
		0,
		window.location.pathname.search("directory") + 10,
	);
	return `<a href="${url}" class="il-button directory-profile-button">Back to Directory</a>`;
}

function processImage(img) {
	if (img.width < 400) {
		img.width = 400;
	}
}

window.addEventListener("DOMContentLoaded", () => {
	main();
});

function processPhone(s) {
	return s.length == 10
		? s.slice(0, 3) + "-" + s.slice(3, 6) + "-" + s.slice(6)
		: "";
}
